import { theme } from '@beamery/lib-ds-theme';
import React from 'react';
import { ParagraphElement } from './paragraph.styles.js';
export const Paragraph = React.forwardRef(({ variant = 'default', elementType = 'p', ...rest }, ref) => (React.createElement(ParagraphElement, { variant: variant, ref: ref, elementType: elementType, ...theme.styles.paragraphs[variant], ...rest })));
//# sourceMappingURL=paragraph.component.js.map